import React from "react"
import ContactFormContainer from "../components/Contact/Container"
import ContactForm from "../components/Contact/Form"
import ContactFormHeader from "../components/Contact/Header"
import Layout from "../components/layout"
import SEO from "../components/seo"

function Contact() {
  return (
    <Layout>
      <SEO title="Contact BeepBeep.uk" />
      <ContactFormContainer>
        <ContactFormHeader />
        <ContactForm />
      </ContactFormContainer>
    </Layout>
  )
}

export default Contact
